import { render, staticRenderFns } from "./ChannelDistributionCustomPage.vue?vue&type=template&id=2020c246&scoped=true&"
import script from "./ChannelDistributionCustomPage.vue?vue&type=script&lang=ts&"
export * from "./ChannelDistributionCustomPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelDistributionCustomPage.vue?vue&type=style&index=0&id=2020c246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020c246",
  null
  
)

export default component.exports